import dynamic from "@redux-dynostore/react-redux";
import subspaced from "@redux-dynostore/react-redux-subspace";
import { attachReducer } from "@redux-dynostore/redux-subspace";
import { match } from "micromatch";
import React, { useEffect } from "react";
import { connect } from "react-redux";
import SmartPageHeader from "../../../components/smart/PageHeader/PageHeader";
import { dashboardType } from "../../../modules/constants";
import LoadingSpinner from "../../ui-library/LoadingSpinner/LoadingSpinner";
import { ToastType } from "../../ToastManager/constants";
import { sendNotification } from "../../ToastManager/ToastManager";
import SurveyAnalytics from "./components/SurveyAnalytics/SurveyAnalytics";
import TotalParticipants from "./components/TotalParticipants/TotalParticipants";
import {
  dashboardReducer,
  mapDispatchToProps,
  mapStateToProps,
} from "./Dashboard.store";

export const Dashboard = (props) => {
  const {
    type,
    data,
    fetchDashboardData,
    dashboardDefinition,
    resetState,
    route,
    studies,
  } = props;

  useEffect(() => {
    if (!data) {
      fetchDashboardData(type).catch((e) =>
        sendNotification(e, ToastType.ERROR)
      );
    }
  }, []);

  useEffect(() => {
    return () => resetState();
  }, [resetState]);

  return (
    <>
      {type === dashboardType.survey ? (
        <SmartPageHeader title={studies[0]?.code} studyId={route.study} />
      ) : (
        <SmartPageHeader
          title={studies && studies[0]?.code}
          studyId={route?.study}
          subtitle=""
          roleName="Participant"
          shouldFetchParticipant={true}
          participantId={match?.params?.participantId}
        />
      )}
      {dashboardDefinition ? (
        dashboardDefinition.map((component, i) => (
          <div key={`dsc-${i}`}>
            {renderByType(component, `${component?.type}-${i}`)}
          </div>
        ))
      ) : (
        <LoadingSpinner />
      )}
    </>
  );
};

const renderByType = (component, widgetId) => {
  switch (component.type) {
    case "totalParticipants":
      return <TotalParticipants {...component} />;
    case "surveyAnalytics": {
      return <SurveyAnalytics {...component} {...{ widgetId }} />;
    }
    default:
      break;
  }
};

export default dynamic(
  "dashboardReducer",
  subspaced({
    // We map extra state because we might need to acess other stores for data, subspace is self contained.
    mapExtraState: (state) => ({ loginReducer: state.loginReducer }),
  }),
  attachReducer(dashboardReducer)
)(connect(mapStateToProps, mapDispatchToProps)(Dashboard));
